import { PHONE_DISPLAY } from "@/constants/site";

const ITEMS = [
  "24/7 TARRANT COUNTY EMERGENCY TOWING",
  PHONE_DISPLAY,
  "FAST RESPONSE",
  "LOCKOUT",
  "JUMPSTART",
  "TIRE CHANGE",
  "WINCH-OUT",
  "LIGHT DUTY TOWING",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="font-display text-lg sm:text-xl font-bold uppercase tracking-wider text-white/90 px-6">
          {item}
        </span>
        <span className="text-emergency font-mono text-sm">///</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div
    className="relative overflow-hidden bg-charcoal border-y border-white/10 py-4 select-none"
    data-testid="editorial-marquee"
  >
    <div className="marquee-track flex w-max">
      <Row hidden={false} />
      <Row hidden={true} />
    </div>
  </div>
);
